import { downloadDrawingAttachment } from '../../../api/drawing';
import { Drawing } from '../../../types/drawing';
import ApprovalStampBox from '../ApprovalStampBox';
import '../../quality/EducationAnnualPlanTab.css';
import '../../quality/QualityShell.css';
import '../../product/InspectionFormSheet.css';
import '../../product/NonconformanceReportPanel.css';
import { PreviewAttachmentList } from './previewShared';

interface Props {
  detail: Drawing;
}

function DrawingPreviewView({ detail }: Props) {
  return (
    <div className="quality-form">
      <section className="quality-form__section">
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            gap: 16,
            alignItems: 'flex-start',
            marginBottom: 12,
          }}
        >
          <h3 style={{ margin: 0 }}>도면</h3>
          <ApprovalStampBox
            authorName={detail.authorName}
            reviewerName={detail.reviewerName}
            approverName={detail.approverName}
          />
        </div>
        <div className="quality-form__grid">
          <label className="is-span-2">
            제목 *
            <input readOnly value={detail.title || ''} />
          </label>
          <label>
            도면번호
            <input readOnly value={detail.drawingNo || ''} />
          </label>
          <label>
            제품코드
            <input readOnly value={detail.productCode || ''} />
          </label>
          <label>
            개정
            <input readOnly value={detail.revision || ''} />
          </label>
          <label className="is-span-2">
            비고
            <textarea rows={3} readOnly value={detail.remark || ''} />
          </label>
        </div>
      </section>

      <section className="quality-form__section">
        <h3 style={{ margin: '0 0 8px' }}>첨부파일</h3>
        <p className="quality-form__hint">도면 파일(PDF·DWG·DXF·이미지 등)을 첨부할 수 있습니다.</p>
        <PreviewAttachmentList
          files={detail.attachments}
          onDownload={(file) => {
            void downloadDrawingAttachment(detail.drawingId, file.attachmentId, file.fileName);
          }}
        />
      </section>
    </div>
  );
}

export default DrawingPreviewView;
